export const temp_categories = [
  {
    Categoryid: -3,
    CategoryName: "Feed",
    Discription: "",
  },
  {
    Categoryid: -1,
    CategoryName: "Today",
    Discription: "",
  },
  {
    Categoryid: -2,
    CategoryName: "Tomorrow",
    Discription: "",
  },
  {
    Categoryid: -4,
    CategoryName: "This Weekend",
    Discription: "",
  },
  {
    Categoryid: 1,
    CategoryName: "Entertainment",
    Discription: "",
  },
  {
    Categoryid: 2,
    CategoryName: "Live Music",
    Discription: "",
  },
  {
    Categoryid: 3,
    CategoryName: "Activities",
    Discription: "",
  },
  {
    Categoryid: 4,
    CategoryName: "Family",
    Discription: "",
  },
  {
    Categoryid: 5,
    CategoryName: "Business",
    Discription: "",
  },
  {
    Categoryid: 6,
    CategoryName: "Tech",
    Discription: "",
  },
  {
    Categoryid: 7,
    CategoryName: "Games",
    Discription: "",
  },
  {
    Categoryid: 8,
    CategoryName: "Health",
    Discription: "",
  },
  {
    Categoryid: 9,
    CategoryName: "Virtual",
    Discription: "",
  },
  {
    Categoryid: 10,
    CategoryName: "Sports",
    Discription: "",
  },
  {
    Categoryid: 11,
    CategoryName: "Party",
    Discription: "",
  },
];

export const popular_location = [
  {
    main: "Las Vegas",
    secondary: "NV, USA",
    lat: "36.1699412",
    lng: "-115.1398296",
  },
  {
    main: "New York",
    secondary: "NV, USA",
    lat: "40.7127753",
    lng: "-74.0059728",
  },
  {
    main: "Atlanta",
    secondary: "NV, USA",
    lat: "33.7489954",
    lng: "-84.3879824",
  },
  {
    main: "Boston",
    secondary: "NV, USA",
    lat: "42.3600825",
    lng: "-71.0588801",
  },
];

export const search_results = [
  {
    EventName: "Glastonbury Farmers' Market",
    Location: "Glastonbury",
    Type: "EventName",
    TimeId: "50530",
    EventId: "59433",
    Image: "https://category-bucket.s3.us-east-2.amazonaws.com/Business.JPG",
  },
  {
    EventName: "Burlington to Collinsville Classic 10K",
    Location: "4 Market St #100,Collinsville,CT",
    Type: "EventName",
    TimeId: "62820",
    EventId: "9180",
    Image: "https://static.mommypoppins.com/hmf_b2c22social_2.png",
  },
  {
    EventName: "Fused Glass Coasters",
    Location: "The Glass Source, 18 BANK STREETSTE 101, Seymour, CT 06483",
    Type: "EventName",
    TimeId: "26379",
    EventId: "965",
    Image: "https://www.newhavenarts.org/hubfs/Events/images/IMG-8868.jpg",
  },
  {
    EventName: "Fused Glass Plate/Bowl Workshop",
    Location: "The Glass Source, 18 BANK STREETSTE 101, Seymour, CT 06483",
    Type: "EventName",
    TimeId: "26390",
    EventId: "46487",
    Image: "https://www.newhavenarts.org/hubfs/Events/images/IMG-8864-1.jpg",
  },
  {
    EventName: "Fused Glass Windchime Workshop",
    Location: "The Glass Source, 18 BANK STREETSTE 101, Seymour, CT 06483",
    Type: "EventName",
    TimeId: "26395",
    EventId: "51352",
    Image: "https://www.newhavenarts.org/hubfs/Events/images/IMG-8871-1.jpg",
  },
];
